import {usePlantStartOfToday} from '@hconnect/upm'
import {Moment} from 'moment-timezone'
import {useMemo} from 'react'

type Range<T> = [start: T, end: T]
type ParsableTime = string | Date | Moment | number
type ParsableTimeRange<T extends ParsableTime = ParsableTime> = Range<T>
export type MomentRange = ParsableTimeRange<Moment>

interface UsePlanRangeParams {
  days?: number
}

export const usePlanRange = ({days = 8}: UsePlanRangeParams = {}): MomentRange => {
  const startOfPlan = usePlantStartOfToday()

  return useMemo(() => {
    const endOfPlan = startOfPlan.clone().add(days, 'day')
    return [startOfPlan, endOfPlan]
  }, [startOfPlan, days])
}
